const sortReplacer = (key, value) =>
  value instanceof Object && !(value instanceof Array)
    ? Object.keys(value)
        .sort()
        .reduce((sorted, key) => {
          sorted[key] = value[key]
          return sorted
        }, {})
    : value

const cachedSort = (key, value) => {
  if (value instanceof Object && !(value instanceof Array)) {
    if (!value._sortedKeys) {
      value._sortedKeys = Object.keys(value).sort()
    }
    return value._sortedKeys.reduce((sorted, key) => {
      sorted[key] = value[key]
      return sorted
    }, {})
  }
  return value
}

export default {
  methods: {
    compareIsChangeArray(originArray, currentArray) {
      let originData = JSON.stringify(originArray, cachedSort)
      let currentData = JSON.stringify(currentArray, cachedSort)
      return originData !== currentData
    },

    compareIsSameArray(originArray, currentArray) {
      let originData = JSON.stringify(originArray, cachedSort)
      let currentData = JSON.stringify(currentArray, cachedSort)
      return originData === currentData
    },

    compareIsChangeObject(originObj, currentObj) {
      let originData = JSON.stringify(originObj, cachedSort)
      let currentData = JSON.stringify(currentObj, cachedSort)
      return originData !== currentData
    },

    compareIsSameObject(originObj, currentObj) {
      let originData = JSON.stringify(originObj, cachedSort)
      let currentData = JSON.stringify(currentObj, cachedSort)
      return originData === currentData
    },

    convertObjectToStringReplacer(obj) {
      return JSON.stringify(obj, cachedSort)
    },

    convertObjectToString(obj) {
      return JSON.stringify(obj)
    },

    deepCopyObject(obj) {
      return JSON.parse(JSON.stringify(obj))
    },

    deepCopyArray(array) {
      return JSON.parse(JSON.stringify(array))
    },

    generateIdToObject() {
      const numberId = Date.now() + Math.floor(Math.random() * 100000)
      return numberId.toString()
    },
  },
}
